import { isValidAppVersion } from '@office-start/capabilities-service';
import { OfficeWorkload, } from '@office-start/officehome-types';
import { logFeature } from '@office-start/telemetry-service';
import { isWindowsAuthAvailable } from './WindowsTokens';
export function shouldEnableNestedAppAuth(officeComponentContext, featureGates) {
    let nestedAppAuthDisabledReason = undefined;
    if (!isFeatureGateEnabled(featureGates)) {
        // Feature gate is not enabled
        nestedAppAuthDisabledReason = 'FEATURE_GATE_NOT_ENABLED';
    }
    else if (officeComponentContext.workload == OfficeWorkload.Hwa) {
        if (!isValidAppVersion({
            build: 1221,
            major: 18,
            minor: 2405,
            revision: 0,
        })) {
            // UWP app version is not supported
            nestedAppAuthDisabledReason = 'UWP_APP_VERSION_NOT_SUPPORTED';
        }
        else if (!isWindowsAuthAvailable) {
            // Windows auth is not available
            nestedAppAuthDisabledReason = 'WINDOWS_AUTH_NOT_AVAILABLE';
        }
    }
    // TODO: implement further checks
    logFeature({
        featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
        eventName: 'NestedAppAuth',
        subArea: 'MOSHubTelemetry',
        params: {
            IsEnabled: !nestedAppAuthDisabledReason,
            DisabledReason: nestedAppAuthDisabledReason !== null && nestedAppAuthDisabledReason !== void 0 ? nestedAppAuthDisabledReason : '',
        },
    });
    if (nestedAppAuthDisabledReason) {
        return false;
    }
    else {
        return true;
    }
}
function isFeatureGateEnabled(featureGates) {
    var _a;
    const fgEnabled = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.authGates) === null || _a === void 0 ? void 0 : _a.authNestedAppAuthEnabled;
    return fgEnabled !== null && fgEnabled !== void 0 ? fgEnabled : false;
}
//# sourceMappingURL=shouldEnableNestedAppAuth.js.map